import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41fcaf16"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "data-radius",
  style: {borderRadius: '4px'}
}


import { defineComponent, defineProps } from 'vue'
import { isEmptyArray, getI18n, getCountryNameByMcc } from '../utils'
import {
  Bottom
} from '@element-plus/icons-vue'
const __default__ = defineComponent({
  name: 'PackageDataDetailCard'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  historyQuota: {
    type: Object,
    require: true
  }
},
  setup(__props) {

const props = __props
function getTotalUsage () {
  let totalUsage = 0.0
  for (let i = 0; i < props.historyQuota.length; i++) {
    totalUsage += Number(props.historyQuota[i].usageData)
  }
  return totalUsage.toFixed(2)
}

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_text = _resolveComponent("el-text")!

  return (getTotalUsage()>0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_row, {
          class: "card-row",
          gutter: 20,
          align: "middle"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tag, {
                  type: 'success',
                  effect: "light"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getI18n)('总用量', 'Total Usage')) + ":", 1)
                  ]),
                  _: 1
                }),
                _createTextVNode("  "),
                _createVNode(_component_el_tag, { effect: "light" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(getTotalUsage()) + "(M)", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 12,
              class: "col-right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tag, {
                  type: 'success',
                  effect: "light"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getI18n)('套餐流量详情', 'Package Data Detail')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode("  "),
                _createVNode(_component_el_tag, { effect: "light" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Bottom))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, {
          class: "card-row",
          gutter: 20,
          align: "middle"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_text, { class: "mx-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getI18n)('发生日期', 'Date')) + "(UTC):", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 86 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_text, { class: "mx-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getI18n)('国家', 'Country')) + ":", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_text, { class: "mx-1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getI18n)('用量', 'Usage')) + "(M):", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!_unref(isEmptyArray)(props.historyQuota))
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.historyQuota, (detail) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: detail.time
              }, [
                (detail.qtaconsumption!=0)
                  ? (_openBlock(), _createBlock(_component_el_row, {
                      key: 0,
                      class: "card-row",
                      gutter: 20,
                      align: "middle"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_text, {
                              class: "mx-1",
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(detail.date), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_text, {
                              class: "mx-1",
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(getCountryNameByMcc)(detail.mcc)), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_el_col, { span: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_text, {
                              class: "mx-1",
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(detail.usageData), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createBlock(_component_el_row, {
        key: 1,
        class: "card-row",
        gutter: 20,
        align: "middle"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: 24,
            class: "line-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_text, { class: "mx-1 line-center-value" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(getI18n)('无数据', 'No Data')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}
}

})